import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MagicWandIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M3.57143 1C3.26936 1 3.01683 1.2158 2.95991 1.50476L2.64685 3.09414L1.47068 3.39271C1.19001 3.46396 1 3.71721 1 4C1 4.28279 1.19001 4.53604 1.47068 4.60729L2.64685 4.90586L2.95991 6.49524C3.01683 6.7842 3.26935 7 3.57143 7C3.8735 7 4.12603 6.7842 4.18294 6.49524L4.496 4.90586L5.67217 4.60729C5.95285 4.53604 6.14286 4.28279 6.14286 4C6.14286 3.71721 5.95285 3.46396 5.67217 3.39271L4.496 3.09414L4.18294 1.50476C4.12603 1.2158 3.8735 1 3.57143 1Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.2898 1.60365L1.60365 11.2898C0.798782 12.0947 0.798787 13.3996 1.60365 14.2045L1.79553 14.3964C2.60039 15.2012 3.90533 15.2012 4.71019 14.3964L14.3964 4.71019C15.2012 3.90533 15.2012 2.60039 14.3964 1.79553L14.2045 1.60365C13.3996 0.798785 12.0947 0.798784 11.2898 1.60365ZM13.3034 2.88853C13.5046 3.08974 13.5046 3.41598 13.3034 3.61719L12.4603 4.46027L11.5397 3.53973L12.3828 2.69664C12.584 2.49543 12.9103 2.49543 13.1115 2.69664L13.3034 2.88853ZM3.53973 11.5397L2.69664 12.3828C2.49543 12.584 2.49543 12.9103 2.69665 13.1115L2.88853 13.3034C3.08974 13.5046 3.41598 13.5046 3.61719 13.3034L4.46027 12.4603L3.53973 11.5397Z"
		></path>
		<path
			fill="currentColor"
			d="M12.9743 10.3419C12.9063 10.1377 12.7152 10 12.5 10C12.2848 10 12.0937 10.1377 12.0257 10.3419L11.6047 11.6047L10.3419 12.0256C10.1377 12.0937 10 12.2848 10 12.5C10 12.7152 10.1377 12.9063 10.3419 12.9743L11.6047 13.3953L12.0257 14.6581C12.0937 14.8623 12.2848 15 12.5 15C12.7152 15 12.9063 14.8623 12.9743 14.6581L13.3953 13.3953L14.6581 12.9743C14.8623 12.9063 15 12.7152 15 12.5C15 12.2848 14.8623 12.0937 14.6581 12.0256L13.3953 11.6047L12.9743 10.3419Z"
		></path>
	</svg>
))
